// Обработчики для событий задач
// Направления: server -> client
import emitter from "../../core/wsEmitter";
import taskProgressService from "../../services/task-progress.service";

emitter.on("task.progress", (data: { progress: number }) => {
	taskProgressService.handleProgress(data);
});

emitter.on("task.rejected", () => {
	taskProgressService.handleRejected();
});
